import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  // private currentUserSubject: BehaviorSubject<User>;
  // public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
    // this.currentUser = this.currentUserSubject.asObservable();
  }

  // login(username: string, password: string) {
  //   return this.http.post<any>(`${environment.apiUrl}/users/authenticate`, { username, password })
  //     .pipe(map(user => {
  //       // login successful if there's a jwt token in the response
  //       if (user && user.token) {
  //         // store user details and jwt token in local storage to keep user logged in between page refreshes
  //         sessionStorage.setItem('currentUser', JSON.stringify(user));
  //         this.currentUserSubject.next(user);
  //       }

  //       return user;
  //     }));
  // }

  // logout() {
  //   // remove user from local storage to log user out
  //   sessionStorage.removeItem('currentUser');
  //   this.currentUserSubject.next(null);
  // }

  isLoggedIn() {
    return sessionStorage.getItem('formToken') || localStorage.getItem('formToken') ? true : false;
  }

  getToken() {
    return sessionStorage.getItem('formToken') || localStorage.getItem('formToken');
  }
}
